import { useEffect, useState } from 'react';

const useBoardPan = function(boardRef) {
  const [pan, setPan] = useState({
    x: 0,
    y: 0
  });

  useEffect(() => {
    const board = boardRef.current;

    let drag = null;

    const start = function(event) {
      if (event.button !== 1) return;

      event.preventDefault();
      event.stopPropagation();
      drag = {
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
      board.setPointerCapture(event.pointerId);
      board.classList.add('isPanning');
    };

    const move = function(event) {
      if (!drag || event.pointerId !== drag.pointerId) return;

      event.preventDefault();

      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;

      drag.x = event.clientX;
      drag.y = event.clientY;

      const next = {
        x: (Number(board.dataset.panX) || 0) + dx,
        y: (Number(board.dataset.panY) || 0) + dy
      };

      board.dataset.panX = next.x;
      board.dataset.panY = next.y;
      setPan(next);
    };

    const finish = function(event) {
      if (!drag || event.pointerId !== drag.pointerId) return;

      drag = null;
      board.classList.remove('isPanning');

      if (board.hasPointerCapture(event.pointerId)) board.releasePointerCapture(event.pointerId);
    };

    const navigate = function(event) {
      if (event.defaultPrevented || event.target !== board || event.altKey || event.ctrlKey || event.metaKey) return;

      const directions = {ArrowLeft: [1, 0], ArrowRight: [-1, 0], ArrowUp: [0, 1], ArrowDown: [0, -1]};
      const direction = directions[event.key];

      if (!direction) return;

      const step = event.shiftKey ? 120 : 40;
      const next = {
        x: (Number(board.dataset.panX) || 0) + direction[0] * step,
        y: (Number(board.dataset.panY) || 0) + direction[1] * step
      };

      event.preventDefault();
      board.dataset.panX = next.x;
      board.dataset.panY = next.y;
      setPan(next);
    };

    const preventAutoscroll = function(event) {
      if (event.button === 1) event.preventDefault();
    };

    board.addEventListener('pointerdown', start, true);
    board.addEventListener('pointermove', move);
    board.addEventListener('pointerup', finish);
    board.addEventListener('pointercancel', finish);
    board.addEventListener('lostpointercapture', finish);
    board.addEventListener('auxclick', preventAutoscroll);
    board.addEventListener('keydown', navigate);

    return () => {
      board.removeEventListener('pointerdown', start, true);
      board.removeEventListener('pointermove', move);
      board.removeEventListener('pointerup', finish);
      board.removeEventListener('pointercancel', finish);
      board.removeEventListener('lostpointercapture', finish);
      board.removeEventListener('auxclick', preventAutoscroll);
      board.removeEventListener('keydown', navigate);
      board.classList.remove('isPanning');
    };
  }, [boardRef]);

  const reveal = function(note, zoom) {
    const board = boardRef.current;

    const next = {
      x: board.clientWidth / 2 - (note.x + note.width / 2) * zoom,
      y: board.clientHeight / 2 - (note.y + note.height / 2) * zoom
    };

    board.dataset.panX = next.x;
    board.dataset.panY = next.y;
    setPan(next);
  };

  return {
    pan,
    reveal,
    setPan
  };
};

export default useBoardPan;
